export default __webpack_public_path__ + "static/media/gb-ork.0408be3e.svg";